/**
 * 带精度向下取整
 * @param value
 * @param precision
 * @returns {number}
 */
export function floor(value, precision) {
  const number = Number(value)
  if (!number && number !== 0) return value
  if (precision) {
    // shift with exponential notation to avoid floating-point issues
    let pair = `${number}e`.split('e')
    const value = Math.floor(`${pair[0]}e${+pair[1] + precision}`)
    pair = `${value}e`.split('e')
    return parseFloat(+`${pair[0]}e${+pair[1] - precision}`).toFixed(precision)
  }
  return Math.floor(number)
}

/**
 * 判断是否为数字
 * @param {number} num
 * @returns {boolean}
 */
export function isNumber(num) {
  if (typeof num === 'number') {
    return num - num === 0
  }
  if (typeof num === 'string' && num.trim() !== '') {
    return (Number.isFinite || isFinite)(+num)
  }
  return false
}

// 获取数字的精度
export function precision() {}

/**
 * 带精度的四舍五入
 * @param value
 * @param precision
 * @returns {number}
 */
export function round(value, precision) {
  const number = Number(value)
  if (!number && number !== 0) return value
  if (precision) {
    // shift with exponential notation to avoid floating-point issues
    let pair = `${number}e`.split('e')
    const value = Math.round(`${pair[0]}e${+pair[1] + precision}`)
    pair = `${value}e`.split('e')
    return +`${pair[0]}e${+pair[1] - precision}`
  }
  return Math.round(number)
}

/**
 * 带精度保留位数
 * @param value
 * @param digits
 * @returns {string}
 */
export function toFixed(value, digits) {
  value = value.toString()
  const dot = value.split('.')[1]
  if (dot && dot.length === digits + 1 && dot.split('')[digits] === '5') {
    value = Number(value) + Math.pow(0.1, digits + 1)
    return Number(value).toFixed(digits)
  } else {
    return Number(value).toFixed(digits)
  }
}

/**
 * 判断对象属性
 * @param {object} obj
 * @param {string} key
 * @returns {boolean}
 */
export function hasOwnProperty(obj, key) {
  if (obj.hasOwnProperty && typeof obj.hasOwnProperty === 'function') {
    // eslint-disable-next-line no-prototype-builtins
    return obj.hasOwnProperty(key)
  } else {
    Object.hasOwnProperty.call(obj, key)
  }
}
/**
 * 判断当前行情是否是最新
 * @param  {object} quote 当前行情信息
 * @param  {object} newQuote 新的行情信息
 * @returns {boolean} 是否最新行情
 */
export function isNewQuote(quote, newQuote) {
  if (!quote) return true
  const timestamp = quote.timestamp || quote.serverTime
  const newTimestamp = newQuote.timestamp || newQuote.serverTime
  if (timestamp && newTimestamp) {
    return newTimestamp >= timestamp
  }
  return true
}
